import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

import { Fab, Box, IconButton, Typography } from '@mui/material';

import { useAuthContext } from 'src/auth/hooks';

import { Iconify } from 'src/components/iconify';

import ChatBot from './chatbot';
import { useChat } from './context/chatbot-provider';

export default function ChatBotWrapper() {
  const location = useLocation();

  const [isOpen, setIsOpen] = useState(false);
  const [showWelcome, setShowWelcome] = useState(false);

  const { user, authenticated, isSelfHealChatBotRequired, isReportsAiChatBotRequired } =
    useAuthContext();

  const { connectSocket, disconnectSocket } = useChat();

  useEffect(() => {
    const seen = sessionStorage.getItem('seenWelcomeMessage');
    if (!seen) {
      setShowWelcome(true);
    }
  }, []);

  const handleChatOpen = () => {
    connectSocket();
    setIsOpen(true);
  };

  const handleChatClose = () => {
    disconnectSocket();
    setIsOpen(false);
  };

  const handleCloseWelcome = () => {
    setShowWelcome(false);
    sessionStorage.setItem('seenWelcomeMessage', 'true');
  };

  // isReportPage
  const isReportPage =
    location.pathname.startsWith('/reports') ||
    new URLSearchParams(location.search).get('from') === 'reports';

  const isReportNeeded = isReportPage && isReportsAiChatBotRequired;
  const selfHeal = !isReportPage && isSelfHealChatBotRequired;

  if (!authenticated || (!isReportNeeded && !selfHeal)) {
    return null;
  }

  return (
    <>
      {showWelcome && (
        <Box
          sx={{
            position: 'fixed',
            bottom: 50,
            right: 90,
            zIndex: 1300,
            bgcolor: '#F1F5FF',
            p: 1.5,
            fontSize: 14,
            color: 'text.primary',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            border: '1px solid #ddd',
            borderRadius: 1.5,
            boxShadow: 3,
            width: 280,
          }}
        >
          <Typography fontSize={14}>Hi 👋 How can I help you today?</Typography>
          <IconButton size="small" onClick={handleCloseWelcome}>
            <Iconify icon="ic:round-close" width={20} />
          </IconButton>
        </Box>
      )}
      {/* Floating Chat Button */}
      {!isOpen && (
        <Box
          sx={{
            position: 'fixed',
            bottom: showWelcome ? 50 : 24,
            right: 24,
            zIndex: 1300,
          }}
        >
          <Fab
            color="primary"
            onClick={() => handleChatOpen()}
            sx={{
              boxShadow: 6,
              background: 'linear-gradient(to right, #4E0F70, #980885)', // blue to purple
              '&:hover': {
                background: 'linear-gradient(to right, #3C2449, #D302B7)', // darker on hover
              },
            }}
          >
            <Iconify icon="mdi:chat" width={24} height={24} />
          </Fab>
        </Box>
      )}

      {/* Chat Interface */}
      {isOpen && (
        <Box
          sx={{
            position: 'fixed',
            bottom: 24,
            right: 24,
            width: {
              xs: '80vw',
              sm: '60vw',
              md: '40vw',
              lg: '35vw',
            },
            maxWidth: 500,
            height: {
              xs: '70vh',
              sm: '80vh',
            },
            zIndex: 1300,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 6,
            overflow: 'hidden',
          }}
        >
          <ChatBot onClose={handleChatClose} user={user} />
        </Box>
      )}
    </>
  );
}
